import { useEffect } from "react";
import { off, on, shareMessage } from "@telegram-apps/sdk";
import { supportsPreparedShareMessage } from "../capabilities";

type TrackCustom = (event: string, params?: Record<string, unknown>) => void;

export const useTelegramReferralInviteTracking = (trackCustom: TrackCustom) => {
    useEffect(() => {
        if (!supportsPreparedShareMessage()) return;

        const handleInvite = () => trackCustom("invited");

        const handleError = (event: { error: string }) => {
            event.error === "USER_DECLINED"
                ? trackCustom("declined")
                : trackCustom("error", { value: event.error });
        };

        on("prepared_message_sent", handleInvite);
        on("prepared_message_failed", handleError);

        return () => {
            off("prepared_message_sent", handleInvite);
            off("prepared_message_failed", handleError);
        };
    }, [trackCustom]);
};

export const sharePreparedMessageInTelegram = async (messageId: string) => {
    if (!shareMessage.isAvailable()) return;
    await shareMessage(messageId);
};

